import { Component, Input, Output, OnInit, AfterContentChecked, EventEmitter, ElementRef } from '@angular/core';
import { ActivatedRoute, Params, Router, NavigationEnd} from '@angular/router';
import { Location } from '@angular/common';
import { ContentService } from '../shared/content.service';
import { UtilsService } from '../shared/utils.service';
import { MetaService } from '../shared/meta.service';
import { IntlService } from '../shared/intl.service';
import { ConfigService } from '../shared/config.service';
import { isNode, isBrowser } from "angular2-universal";
import { NameResolverPipe } from '../shared/name-resolver.pipe';

const type: string = 'record';
declare var bLazy;

@Component({
    template: require('./partials/content-records.html'),
    providers: [NameResolverPipe]
})
export class ContentRecordsComponent implements OnInit, AfterContentChecked {
    public isServer: boolean = true;
    public hasFilter: boolean = false;
    public currentSearch: string;
    public currentLanguage: string;
    public contents: any;
    public currentPage: number = 1;
    public pageSize: number = 12; 
    public isFirstPage: boolean = false;
    public entryType: string = null;
    public entryField: string;
    public entryFieldValue: string;
    @Output() onSearch: EventEmitter<Object> = new EventEmitter<Object>();

    constructor(private nameResolver: NameResolverPipe, private elementRef: ElementRef, public config: ConfigService, public utils: UtilsService, public intl: IntlService, private metaService: MetaService, private contentService: ContentService, private route: ActivatedRoute, private location: Location, private router: Router) {
    }

    ngOnInit(){  

        this.isServer = !isBrowser; 

        // Update hasFilter and entryType for display purposes
        this.router.events.subscribe((evt) => {
            if (evt instanceof NavigationEnd) {
                // Has filter or not
                this.hasFilter = false;
                if(this.route.snapshot.queryParams['s'] || this.route.snapshot.queryParams['f'] || this.route.snapshot.params['field']){
                    this.hasFilter = true;
                }
                // Entry type
                this.entryType = this.route.snapshot.params['type'];
                // Entry field = 
                this.entryField = this.route.snapshot.params['field'];
                // Language (parent route)
                if(this.route.parent.snapshot.params['lg']){
                    this.currentLanguage = this.route.parent.snapshot.params['lg'];
                    // Meta
                    let metaTitle = this.intl.data.COMMON.MENU.CATALOGUE[this.currentLanguage];
                    if(this.entryType)
                        metaTitle += ' | ' +  this.intl.data.COMMON.TAXONOMY.type.VALUES[this.entryType][this.currentLanguage];
                    else if(this.entryField)
                        metaTitle += ' | ' +  this.nameResolver.transform(this.route.snapshot.params['value']);
                    this.metaService.setLanguage(this.currentLanguage); 
                    this.metaService.setMeta(this.config.data.APP.FRONT.TITLE + ' | ' + metaTitle, this.intl.data.COMMON.SUMMARY[this.currentLanguage], this.intl.data.COMMON.KEYWORDS[this.currentLanguage]);                 
                }
            }
        });

        // Parent route properties
        // this.route.parent.params.subscribe((params: Params) => {
        //     // Current language
        //     this.currentLanguage = params['lg'];
        //     // Meta language
        //     this.metaService.setLanguage(this.currentLanguage);

        // });
        
        this.route.params.subscribe((params: Params) => {
            if(params['field']!=null){
                // Set page size to max so as to expose as much content as possible for SEO
                this.pageSize = 1000;
            }
        });

        this.route.queryParams.subscribe(params => {
            // Current search
            this.currentSearch = params['s']; 
            // Is first page
            if(params['from']!=null)
                this.isFirstPage = false;
            else {
                this.isFirstPage = true;
                this.currentPage = 1;    
            }
        });

    }

    ngAfterContentChecked(){
        if(!this.currentLanguage){
            this.currentLanguage = this.config.data.APP.LANGUAGES.PREFERRED;
            // this.config.get().then(res=>{
            //     if(res.data){
            //         this.config = res;
            //         this.currentLanguage = this.config.data.APP.LANGUAGES.PREFERRED;
            //         // Meta language
            //         this.metaService.setLanguage(this.currentLanguage);
            //     }
            // });
        }     
    }

    public onPageChange(event: any, target: string): void {
        this.currentPage = event.currentPage;
        let from = ( this.currentPage - 1 ) * this.pageSize;
        // Callback log
        this.onSearch.emit('page '+this.currentPage);
        // Nav
        let params = {};
        for(let qp in this.route.snapshot.queryParams){
            params[qp] = this.route.snapshot.queryParams[qp];
        }
        params['from'] = from; 
        this.router.navigate(['.'], { relativeTo: this.route, queryParams: params });
    };

} 


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/front/content-records.component.ts